import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProfileContextConsumer } from '../../../common/context/profile/context';
import HeroBanner from '../../../common/heroBanner';

const ProfileHeroBanner = (props) => {
  const { partnerDetails, loading } = props || {};
  const { display_name: displayName, headline, contact_link: rawContactLink } = partnerDetails || {};
  const { t: translate } = useTranslation('detail');
  // Check url with Web url phone ni or email
  let contactLink = '';
  if (rawContactLink) {
    const trimmedLink = rawContactLink.trim();
    if (/^https?:\/\//i.test(trimmedLink)) {
      contactLink = trimmedLink;
    } else if (/^[\w.-]+@[\w.-]+\.\w{2,}$/i.test(trimmedLink) && /^mailto:\/\//i.test(trimmedLink)) {
      contactLink = trimmedLink;
    } else if (/^[\w.-]+@[\w.-]+\.\w{2,}$/i.test(trimmedLink)) {
      contactLink = `mailto:${trimmedLink}`;
    } else if (/^\+?\d[\d\s-]{7,}$/i.test(trimmedLink) && /^tel:\/\//i.test(trimmedLink)) {
      contactLink = trimmedLink;
    } else if (/^\+?\d[\d\s-]{7,}$/i.test(trimmedLink)) {
      contactLink = `tel:${trimmedLink.replace(/\s+/g, '')}`;
    } else {
      contactLink = `https://${trimmedLink.replace(/^\/\//, '')}`;
    }
  }
  return (
    <HeroBanner translate={translate} contactLink={contactLink} loading={loading} displayName={displayName} title={headline} />
  );
};
export default ProfileContextConsumer(ProfileHeroBanner);
